import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import { Multilingual } from 'src/app/services/multilingual';
import { ProductivityService } from 'src/app/services/productivity-service';
import { TranslaterService } from 'src/app/services/translater.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import * as  Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import More from 'highcharts/highcharts-more';
import ExportData from 'highcharts/modules/export-data';
import Accessibility from 'highcharts/modules/accessibility';
More(Highcharts);
Exporting(Highcharts);
ExportData(Highcharts);
Accessibility(Highcharts);

@Component({
  selector: 'app-live-dashboard',
  templateUrl: './live-dashboard.component.html',
  styleUrls: ['./live-dashboard.component.scss']
})
export class LiveDashboardComponent implements OnInit {
  static ProductionDataglobal: any;
  chartProductionCount!: Chart;
  options: any;
  LiveDashboardForm!: FormGroup;
  filteredGroups: any;
  filteredPlants: any;
  filteredLines: any;
  filteredUnits: any;
  filteredParameterGroup: any;
  breadcrumList: any;
  IsAccess: any;
  IsWrite: any;
  GroupList!: any[];
  PlantList1!: any[];
  lineList!: any[];
  unitList!: any[];
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  lang: any;
  key: any;
  Count!:any;
  Status!:any;
  Alarm!:any;
  myArr :any[] = new Array();
  OeeData!:any;
  productionData:any[] = new Array();
  oeeAnalysis = {
    barType: 'radial',
    color: '#10CE9C',
    secondColor: '#E5E5E5',
    progress: 0,
    radial: {
      depth: 8,
      size: 96,
      label: {
        enable: true,
        color: '#09608c',
      },
    },
  };
  capacityUtilizationAnalysis = {
    barType: 'radial',
    color: '#3AAFE4',
    secondColor: '#E5E5E5',
    progress: 0,
    radial: {
      depth: 8,
      size: 96,
      label: {
        enable: true,
        color: '#09608c',
      },
    },
  };
  availabilityAnalysis = {
    barType: 'radial',
    color: '#F85439',
    secondColor: '#E5E5E5',
    progress: 0,
    radial: {
      depth: 8,
      size: 96,
      label: {
        enable: true,
        color: '#F85439',
      },
    },
  };
  performanceAnalysis = {
    barType: 'radial',
    color: '#3AAFE4',
    secondColor: '#E5E5E5',
    progress: 0,
    radial: {
      depth: 8,
      size: 96,
      label: {
        enable: true,
        color: '#09608c',
      },
    },
  };

  qualityAnalysis = {
    barType: 'radial',
    color: '#F85439',
    secondColor: '#E5E5E5',
    progress: 0,
    radial: {
      depth: 8,
      size: 96,
      label: {
        enable: true,
        color: '#F85439',
      },
    },
  };
  constructor( private kpiMaster: KpimasterService, private formBuilder: FormBuilder,
    private usermanagementService: UserManagementService,
    private productivityservice: ProductivityService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    public router: Router,
    private translater: TranslaterService,
    private translate: TranslateService) { }

  ngOnInit(): void {
    this.initForm();
    this.GetBreadcrumList();
    this.GetMenuAccess();
    this.datasource();
  }
  initForm() {
    const dateStart = new Date();
    //dateStart.setDate(dateStart.getDate() - 183);
    dateStart.setHours(6);
    dateStart.setMinutes(0);
    dateStart.setSeconds(0);

    const dateEnd = new Date();
    dateEnd.setDate(dateEnd.getDate());

    this.LiveDashboardForm = this.formBuilder.group({
      UserGroup1: ['', Validators.required],
      UserPlant1: ['', Validators.required],
      unit: ['', Validators.required],
      line: ['', Validators.required],
      dateStart: [dateStart, Validators.required],
      dateEnd: [dateEnd, Validators.required],
      shift: ['', []],
      searchval: [''],
      parameterGroup : []
    });
  }

  onChangeGroup(data: any): void {
    this.getPlants(data);
  }
  onChangeLine(data: any): void {
    this.getUnit(data.value);
  }
  onChangePlant(data: any): void {
    this.getLine(data.value);
  }

  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.kpiMaster.GetMenuAccess(key).subscribe(
      (data: any) => {
        // this.permisson = data;
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
      //  this.gridApi.refreshHeader();
      }
    });
  }

  //menu and breadcrumb
  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    // tslint:disable-next-line: align
    this.usermanagementService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
        this.getLangWords();
        this.lang = new Multilingual(this.translater, this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  datasource(): void {
    const key = {
      UserId: 206, //later it will be change this is only for testing
    };
    const id = {
      value: 0,
    };
    this.productivityservice.getGroupData(key).subscribe(
      (data: any) => {
        this.GroupList = data.lstEG;
        if (this.GroupList.length > 0) {
          id.value = data.lstEG[0].EG_Id;
       
            this.LiveDashboardForm.patchValue({
              UserGroup1: data.lstEG[0].EG_Id,
              UserPlant1: data.lstEG[0].EG_Id,
            });
          this.filteredGroups = this.GroupList.slice();
          this.getPlants(id);
        }
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }

  getPlants(event: any): void {
    const key = {
      EG_ID: this.LiveDashboardForm.value.UserGroup1,
      userId: 206,
    };
    this.productivityservice.getPlantsData(key).subscribe(
      (data: any) => {
        this.PlantList1 = data.lstPlant;
        if (this.PlantList1.length > 0) {
          const id = data.lstPlant[0].PT_Id;
            this.LiveDashboardForm.get('UserPlant1')?.patchValue(id);
            this.getLine(id);
          }
          this.filteredPlants = this.PlantList1.slice();
       
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  getLine(id: any) {
    const key = {
      PT_ID: this.LiveDashboardForm.value.UserPlant1,
      userId: 206,
    };

    this.productivityservice.getLineData(key).subscribe(
      (data: any) => {
        this.lineList = data.lstLine;
        if (this.lineList.length > 0) {
          const lineDefault = this.lineList[0];
            this.LiveDashboardForm.controls.line.patchValue(lineDefault.PL_Id);
          this.filteredLines = this.lineList.slice();
          this.getUnit(lineDefault.PL_Id);
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  getUnit(id: number) {
    const key = {
      PL_ID: this.LiveDashboardForm.value.line,
      userId: 206,
    };

    this.productivityservice.getUnitData(key).subscribe(
      (data: any) => {
        this.unitList = data.lstUnit;
        if (this.unitList.length > 0) {
          this.filteredUnits = this.unitList.slice();
          const unitDefault = this.unitList[0];
          this.LiveDashboardForm.get('unit').setValue(unitDefault.PU_Id);
          this.onSubmit();
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  intervel = setInterval(() => {
    if (this.LiveDashboardForm.get('unit').value) {
      this.GetDashBoradData();
    }

  }, 1000);

  intervelforoee = setInterval(() => {
    if (this.LiveDashboardForm.get('unit').value) {
      this.getOeeData();
    }

  }, 60000);

  GetDashBoradData() {
    const key = {
      Id: this.LiveDashboardForm.value.unit
    };

    this.productivityservice.getDashboardDataMongo(key).subscribe(
      (data: any) => {
        LiveDashboardComponent.ProductionDataglobal = data;
        this.productionData=[];
        if(this.myArr.length >=3){
          this.myArr =[];
        }
        this.myArr.push(parseInt(data[0].TagValue));
        this.productionData.push({x:new Date().getTime(),y:parseInt(data[0].TagValue)});
        this.Count=parseInt(data[0].TagValue);
        this.Status = data[1].TagValue === 'True' ? 'Running' : 'Stopped'
        this.Alarm =  data[2].TagValue === '1001' ? 'Emergency Stopped' : data[2].TagValue === '1002' ? 'High Speed' : data[2].TagValue === '1003' ? 'Low Speed' : data[2].TagValue === '1004' ? 'High Pressure' : this.myArr[this.myArr.length -2] === parseInt(data[0].TagValue) ? 'Idle' : ''
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  onSubmit(){
  this.ProductionCount();
  this.machineRunningStatus();
  }

  ProductionCount(){
    Highcharts.chart('chartProductionCount', {
      chart: {
        type: 'spline',
        animation:(Highcharts as any).SVGRenderer, // don't animate in old IE
        marginRight: 10,
        events: {
          load: function () {
    
            // set up the updating of the chart each second
            var series = this.series[0];
            setInterval(function () {
              var x = new Date().getTime(), // current time
                y = parseInt(LiveDashboardComponent.ProductionDataglobal[0].TagValue);
              series.addPoint([x, y], true, true);
            }, 1000);
          }
        }
      },
    
      time: {
        useUTC: false
      },
    
      title: {
        text: ''
      },
      credits: {
        enabled: false,
      },
      accessibility: {
        announceNewData: {
          enabled: true,
          minAnnounceInterval: 15000,
          announcementFormatter: function (allSeries, newSeries, newPoint) {
            if (newPoint) {
              return 'New point added. Value: ' + newPoint.y;
            }
            return false;
          }
        }
      },
    
      xAxis: {
        type: 'datetime',
        tickPixelInterval: 150
      },
    
      yAxis: {
        title: {
          text: 'Value'
        },
        plotLines: [{
          value: 0,
          width: 1,
          color: '#808080'
        }]
      },
    
      tooltip: {
        headerFormat: '<b>{series.name}</b><br/>',
        pointFormat: '{point.x:%Y-%m-%d %H:%M:%S}<br/>{point.y:.2f}'
      },
    
      legend: {
        enabled: false
      },
    
      exporting: {
        enabled: false
      },
    
      series: [{
        name: 'Production',
        type:'spline',
        data: (function () {
          // generate an array of random data
          var data = [],
            time = (new Date()).getTime(),
            i;
    
          for (i = -19; i <= 0; i += 1) {
            data.push({
              x: time + i * 1000,
              y: Math.random()
            });
          }
          return data;
        }())
      }]
    });
  }

  machineRunningStatus(){
    Highcharts.chart('chartMachineStatus', {
      chart: {
        type: 'spline',
        animation:(Highcharts as any).SVGRenderer, // don't animate in old IE
        marginRight: 10,
        events: {
          load: function () {
    
            // set up the updating of the chart each second
            var series = this.series[0];
            setInterval(function () {
              var x = new Date().getTime(), // current time
              y = LiveDashboardComponent.ProductionDataglobal[1].TagValue === 'True' ? 1 : 0;
              series.addPoint([x, y], true, true);
            }, 1000);
          }
        }
      },
    
      time: {
        useUTC: false
      },
    
      title: {
        text: ''
      },
      credits: {
        enabled: false,
      },
      accessibility: {
        announceNewData: {
          enabled: true,
          minAnnounceInterval: 15000,
          announcementFormatter: function (allSeries, newSeries, newPoint) {
            if (newPoint) {
              return 'New point added. Value: ' + newPoint.y;
            }
            return false;
          }
        }
      },
    
      xAxis: {
        type: 'datetime',
        tickPixelInterval: 150
      },
    
      yAxis: {
        title: {
          text: 'Value'
        },
        plotLines: [{
          value: 0,
          width: 1,
          color: '#808080'
        }]
      },
    
      tooltip: {
        headerFormat: '<b>{series.name}</b><br/>',
        pointFormat: '{point.x:%Y-%m-%d %H:%M:%S}<br/>{point.y:.2f}'
      },
    
      legend: {
        enabled: false
      },
    
      exporting: {
        enabled: false
      },
    
      series: [{
        name: 'Machine',
        type:'spline',
        data: (function () {
          // generate an array of random data
          var data = [],
            time = (new Date()).getTime(),
            i;
    
          for (i = -19; i <= 0; i += 1) {
            data.push({
              x: time + i * 1000,
              y: Math.random()
            });
          }
          return data;
        }())
      }]
    });
  }

  //===============================================OEE code ====================================================//
  getOeeData() {
    const stDT = new Date();
    stDT.setDate(stDT.getDate());
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);
    const edDT = new Date();
    edDT.setDate(edDT.getDate());
  
    this.key = {
      dtStartDate: stDT,
      dtEndDate: edDT,
      GroupId: this.LiveDashboardForm.value.UserGroup1,
      PlantId: this.LiveDashboardForm.value.UserPlant1,
      UnitId: this.LiveDashboardForm.value.unit,
      LineId: this.LiveDashboardForm.value.line,
      shift: '*',
    };
    this.spinner.show();
    this.productivityservice.getOEE(this.key).subscribe(
      (data: any) => {
        this.OeeData = data;
        this.spinner.hide();
        this.setData();
      },
      (error: any) => {
        this.toaster.error('error', error.message);
        this.spinner.hide();
      }
    );
  }

  setData() {
    this.capacityUtilizationAnalysis.progress =
      this.OeeData.CUPerc.toFixed(0);
    this.oeeAnalysis.progress =
      this.OeeData.AvgOee >= 100
        ? this.OeeData.AvgOee.toFixed(0)
        : this.OeeData.AvgOee.toFixed(0);
    this.availabilityAnalysis.progress =
      this.OeeData.AvgAvailability >= 100
        ? this.OeeData.AvgAvailability.toFixed(0)
        : this.OeeData.AvgAvailability.toFixed(0);
    this.performanceAnalysis.progress =
      this.OeeData.AvgPerformance >= 100
        ? this.OeeData.AvgPerformance.toFixed(0)
        : this.OeeData.AvgPerformance.toFixed(0);
    this.qualityAnalysis.progress =
      this.OeeData.AvgQualityRate >= 100
        ? this.OeeData.AvgQualityRate.toFixed(0)
        : this.OeeData.AvgQualityRate.toFixed(0);
    this.setColorCoding();
  }

  setColorCoding() {
    //OEE
    if (this.oeeAnalysis.progress > 0 && this.oeeAnalysis.progress <= 20) {
      this.oeeAnalysis.color = '#fa1f0f';
    } else if (
      this.oeeAnalysis.progress > 20 &&
      this.oeeAnalysis.progress <= 50
    ) {
      this.oeeAnalysis.color = '#fae311';
    } else if (
      this.oeeAnalysis.progress > 50 &&
      this.oeeAnalysis.progress <= 70
    ) {
      this.oeeAnalysis.color = '#fc7005';
    } else if (this.oeeAnalysis.progress > 70) {
      this.oeeAnalysis.color = '#069420';
    }
    //CU
    if (
      this.capacityUtilizationAnalysis.progress > 0 &&
      this.capacityUtilizationAnalysis.progress <= 20
    ) {
      this.capacityUtilizationAnalysis.color = '#fa1f0f';
    } else if (
      this.capacityUtilizationAnalysis.progress > 20 &&
      this.capacityUtilizationAnalysis.progress <= 50
    ) {
      this.capacityUtilizationAnalysis.color = '#fae311';
    } else if (
      this.capacityUtilizationAnalysis.progress > 50 &&
      this.capacityUtilizationAnalysis.progress <= 70
    ) {
      this.capacityUtilizationAnalysis.color = '#fc7005';
    } else if (this.capacityUtilizationAnalysis.progress > 70) {
      this.capacityUtilizationAnalysis.color = '#069420';
    }
    // Availability
    if (
      this.availabilityAnalysis.progress > 0 &&
      this.availabilityAnalysis.progress <= 20
    ) {
      this.availabilityAnalysis.color = '#fa1f0f';
    } else if (
      this.availabilityAnalysis.progress > 20 &&
      this.availabilityAnalysis.progress <= 50
    ) {
      this.availabilityAnalysis.color = '#fae311';
    } else if (
      this.availabilityAnalysis.progress > 50 &&
      this.availabilityAnalysis.progress <= 70
    ) {
      this.availabilityAnalysis.color = '#fc7005';
    } else if (this.availabilityAnalysis.progress > 70) {
      this.availabilityAnalysis.color = '#069420';
    }
    //performanceAnalysis
    if (
      this.performanceAnalysis.progress > 0 &&
      this.performanceAnalysis.progress <= 20
    ) {
      this.performanceAnalysis.color = '#fa1f0f';
    } else if (
      this.performanceAnalysis.progress > 20 &&
      this.performanceAnalysis.progress <= 50
    ) {
      this.performanceAnalysis.color = '#fae311';
    } else if (
      this.performanceAnalysis.progress > 50 &&
      this.performanceAnalysis.progress <= 70
    ) {
      this.performanceAnalysis.color = '#fc7005';
    } else if (this.performanceAnalysis.progress > 70) {
      this.performanceAnalysis.color = '#069420';
    }
    //qualityAnalysis
    if (
      this.qualityAnalysis.progress > 0 &&
      this.qualityAnalysis.progress <= 20
    ) {
      this.qualityAnalysis.color = '#fa1f0f';
    } else if (
      this.qualityAnalysis.progress > 20 &&
      this.qualityAnalysis.progress <= 50
    ) {
      this.qualityAnalysis.color = '#fae311';
    } else if (
      this.qualityAnalysis.progress > 50 &&
      this.qualityAnalysis.progress <= 70
    ) {
      this.qualityAnalysis.color = '#fc7005';
    } else if (this.qualityAnalysis.progress > 70) {
      this.qualityAnalysis.color = '#069420';
    }
  }

}
function getTime(){
return LiveDashboardComponent.ProductionDataglobal[0].Servertime;
}